import React from 'react';
import './ProductCatagories.css';
import { Link } from "react-router-dom";
import Domestic from './img9.jpg'
const ProductCategories = () => {
  return (
    <div className="mainHome-container1">

        <div className="ALLOYMETALS-herosection" >
            <div className="Medical-herosection-pic-section">
                <div className="ALLOYMETALS-herosection-heading">
                    HOME / Medical Equipment
                </div>
            
            </div>
            
        </div>
        <div className="Each-Product-container" >
        

            <div className="Each-Product-mid-left-container">
                <div className='Each-Product-tittle'>
                Medical Equipment
                </div>
                <div className='Each-Product-mid-details'>
                At GaganaSAI International, we take pride in our proven track record as a trusted supplier of medical and surgical equipment across the Middle East. As a leading medical equipment provider in Hyderabad, India, we offer cutting-edge products to hospitals and healthcare facilities, ensuring they have the essential tools needed to overcome equipment shortages and meet the demands of modern healthcare. Our commitment to quality, sustainability, and affordability has earned us the trust of a growing number of clients.
                </div>
            </div>
            <div className="Each-Product-mid-right-container">
                <div className="tranding-pics">
                    <img src={Domestic} alt="" className='tranding-left-pics' />
                </div>

            </div>
        </div>
    <section className="Each-Product-Details-card" style={{height:"auto", paddingBottom:"50px"}}>
      <h2>WHY PARTNER WITH US ?</h2>
      
      <section className="product-categories-list">
      <div className="product-categories-list-header">
        
      </div>

      <div className="product-categories-list-grid">
        {productCategoryDetails.map((productCategory, index) => (
          <div key={index} className="product-categories-list-box">
            <div className="Each-product-benifitt-icon"><img src={productCategory.image} alt={productCategory.image} className='product-section-img'/></div>
            <h3>{productCategory.title}</h3>
            <p>{productCategory.description}</p>
          </div>
        ))}
      </div>
    </section>
      {/* <button className="view-button">View All Products</button> */}
      {/* <h2 className='Product-category-title'>Browse by Category</h2> */}
    </section>
    
    </div>
  );
};

export default ProductCategories;

const productCategoryDetails = [
    {
      title: "Top-Tier Quality",
      description: "We prioritize quality in everything we do. All of our products adhere to global healthcare regulations and certifications, ensuring that your medical facility receives only the highest-quality equipment.",
      image: "/Products/Medical/1.jpg"
    },
    {
      title: "Custom Solutions",
      description: "We understand that every medical facility has unique requirements. Our team works closely with you to provide tailored solutions, ensuring you receive the specific equipment needed to enhance your operations.",
      image: "/Products/Medical/2.jpg"
    },
    {
      title: "Timely Delivery",
      description: "With our robust logistics network, we guarantee prompt and reliable delivery, no matter where your facility is located. From anywhere in the world, we ensure your medical equipment arrives on time, ready for use.",
        image: "/Products/Medical/3.png"
    },

    
  ];
  